import { useEffect, useState } from "react"
import AccountService from "../../api/AccountService";

export default function useTwoFactorIsEnabled() {
    const [isLoading, setIsLoading] = useState(false);
    const [isEnabled, setIsEnabled] = useState(null);

    useEffect(() => {
        fetchData();
    }, [])

    async function fetchData() {
        setIsLoading(true);
        try {
            const response = await AccountService.TwoFactorIsEnabled();
            setIsEnabled(response.isEnabled);
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    }

    async function reload() {
        await fetchData();
    }

    return [isEnabled, isLoading, reload];
}